var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgZoomIn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 17",
    fill: "none",
    className: "mdl-js",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06448 5.94726C9.06446 5.94976 9.06445 5.95226 9.06445 5.95477C9.06445 6.50706 9.51217 6.95477 10.0645 6.95477L10.0645 6.95477L14.0645 6.95477C14.6167 6.95477 15.0645 6.50706 15.0645 5.95477C15.0645 5.40249 14.6167 4.95477 14.0645 4.95477L12.4636 4.95477L15.7071 1.71128C16.0976 1.32075 16.0976 0.687589 15.7071 0.297064C15.3166 -0.0934601 14.6834 -0.0934602 14.2929 0.297064L11.0645 3.52548L11.0645 1.95477C11.0645 1.40249 10.6168 0.954772 10.0645 0.954772C9.5122 0.954772 9.06448 1.40249 9.06448 1.95477L9.06448 5.94726Z",
    fill: "#d6d6d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70711 15.7112L4.13556 13.2828L4.13556 14.8836C4.13556 15.4359 4.58327 15.8836 5.13556 15.8836C5.68784 15.8836 6.13556 15.4359 6.13556 14.8836L6.13556 10.8836C6.13556 10.3313 5.68784 9.88361 5.13556 9.88361H1.13555C0.583269 9.88361 0.135553 10.3313 0.135553 10.8836C0.135553 11.4359 0.583269 11.8836 1.13555 11.8836H2.70631L0.292893 14.297C-0.0976309 14.6875 -0.097631 15.3207 0.292893 15.7112C0.683418 16.1018 1.31658 16.1018 1.70711 15.7112Z",
    fill: "#d6d6d6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZoomIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/zoomIn.b7e5386c.svg";
export { ForwardRef as ReactComponent };